import { LegalPage } from '../components/LegalPage';

export default function TermsPage() {
  return (
    <LegalPage
      title="Termini e Condizioni"
      lastUpdated="30 marzo 2026"
      activePage="/terms"
    >

      <div className="highlight-box">
        <p style={{ marginBottom: 0 }}>
          I presenti Termini e Condizioni ("Contratto") disciplinano l'accesso e l'utilizzo della piattaforma <strong>Shangrilux</strong> da parte dei clienti B2B ("Cliente"). Utilizzando il Servizio, il Cliente dichiara di aver letto, compreso e accettato integralmente le presenti condizioni. Il Contratto è regolato dalla legge italiana.
        </p>
      </div>

      <h2>Changelog delle Modifiche</h2>
      <p>
        In questa sezione sono documentate tutte le modifiche rilevanti ai presenti Termini e Condizioni, in ordine cronologico decrescente. I Clienti attivi ricevono notifica via email almeno 30 giorni prima dell'entrata in vigore di ogni modifica sostanziale.
      </p>
      <table>
        <thead>
          <tr>
            <th>Data</th>
            <th>Versione</th>
            <th>Tipo</th>
            <th>Descrizione</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>30 mar 2026</strong></td>
            <td>1.0</td>
            <td>Pubblicazione iniziale</td>
            <td>Prima versione ufficiale dei Termini e Condizioni Shangrilux. Comprende: definizioni, piani di abbonamento (Essenziale €300/mese, Professional €750/mese, Elite €1.500/mese), fatturazione annuale, periodo di grazia 30 giorni, SLA 99,5%, obblighi DPA art. 28 GDPR, limitazione di responsabilità, legge italiana.</td>
          </tr>
        </tbody>
      </table>
      <p style={{ fontSize: '12px', color: 'rgba(229,229,229,0.35)', marginTop: '-6px' }}>
        Le versioni precedenti dei Termini e Condizioni sono disponibili su richiesta inviando email a <a href="mailto:info@shangrilux.com">info@shangrilux.com</a>.
      </p>

      <h2>1. Definizioni</h2>
      <ul>
        <li><strong>"Fornitore"</strong>: Francesco Russo, titolare della piattaforma Shangrilux, con sede legale in Italia, raggiungibile all'indirizzo <a href="mailto:info@shangrilux.com">info@shangrilux.com</a>.</li>
        <li><strong>"Cliente"</strong>: la persona fisica o giuridica che stipula un contratto di abbonamento per l'utilizzo della Piattaforma.</li>
        <li><strong>"Piattaforma"</strong>: il software SaaS Shangrilux, disponibile all'indirizzo <a href="https://shangrilux.com">https://shangrilux.com</a>, comprensivo di tutte le funzionalità incluse nel piano sottoscritto.</li>
        <li><strong>"Tenant"</strong>: l'ambiente isolato e dedicato al Cliente all'interno della Piattaforma multi-tenant di Shangrilux.</li>
        <li><strong>"Ospite"</strong>: il cliente finale del Cliente (es. ospite dell'hotel o dell'affitto breve), i cui dati possono essere gestiti tramite la Piattaforma.</li>
        <li><strong>"Piano"</strong>: il livello di abbonamento scelto dal Cliente tra quelli disponibili (Essenziale, Professional, Elite).</li>
        <li><strong>"DPA"</strong>: Accordo sul Trattamento dei Dati (Data Processing Agreement) di cui all'art. 28 GDPR, allegato al presente Contratto.</li>
      </ul>

      <h2>2. Oggetto del Contratto</h2>
      <p>
        Il Fornitore concede al Cliente un accesso non esclusivo, non trasferibile e limitato alla Piattaforma Shangrilux, per il periodo di abbonamento sottoscritto e nei limiti del Piano scelto. Il Servizio è erogato come Software-as-a-Service (SaaS) e non comporta alcun trasferimento di licenza software, né il rilascio del codice sorgente.
      </p>

      <h2>3. Registrazione e Accesso</h2>
      <p>
        Per accedere alla Piattaforma, il Cliente deve completare il processo di registrazione e fornire informazioni accurate e veritiere. Il Cliente è responsabile di:
      </p>
      <ul>
        <li>Mantenere riservate le proprie credenziali di accesso</li>
        <li>Notificare immediatamente al Fornitore qualsiasi accesso non autorizzato al proprio account</li>
        <li>Garantire che il numero di utenti admin non superi quanto previsto dal Piano sottoscritto</li>
        <li>Utilizzare la Piattaforma esclusivamente per finalità lecite e in conformità al presente Contratto</li>
      </ul>

      <h2>4. Demo Gratuita</h2>
      <p>
        Il Fornitore può mettere a disposizione ambienti demo gratuiti della durata di <strong>24 ore</strong>. Gli ambienti demo:
      </p>
      <ul>
        <li>Sono generati automaticamente al momento della richiesta</li>
        <li>Contengono dati di esempio e non dati reali</li>
        <li>Vengono eliminati automaticamente allo scadere delle 24 ore</li>
        <li>Sono soggetti a tutti i presenti Termini e Condizioni, ad eccezione degli obblighi di pagamento</li>
        <li>Possono essere disattivati anticipatamente dal Fornitore senza preavviso</li>
      </ul>
      <p>L'utilizzo della demo non crea alcun obbligo contrattuale tra le parti.</p>

      <h2>5. Piani di Abbonamento e Prezzi</h2>
      <p>La Piattaforma è disponibile nei seguenti piani:</p>
      <table>
        <thead>
          <tr>
            <th>Piano</th>
            <th>Canone mensile equiv.</th>
            <th>Fatturazione</th>
            <th>Proprietà</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Essenziale</strong></td>
            <td>€300/mese</td>
            <td>€3.600/anno</td>
            <td>1 proprietà</td>
          </tr>
          <tr>
            <td><strong>Professional</strong></td>
            <td>€750/mese</td>
            <td>€9.000/anno</td>
            <td>Fino a 5 proprietà</td>
          </tr>
          <tr>
            <td><strong>Elite</strong></td>
            <td>€1.500/mese</td>
            <td>€18.000/anno</td>
            <td>Illimitate</td>
          </tr>
        </tbody>
      </table>
      <p>
        I prezzi sono espressi in Euro e si intendono IVA esclusa, salvo diversa indicazione. Il Fornitore si riserva il diritto di modificare i prezzi con preavviso di almeno <strong>60 giorni</strong> ai Clienti esistenti. Le modifiche di prezzo non si applicano al periodo di abbonamento in corso.
      </p>

      <h2>6. Fatturazione e Pagamento</h2>
      <p>
        L'abbonamento è fatturato <strong>annualmente in anticipo</strong>. Il pagamento avviene tramite link di pagamento sicuro generato dal Fornitore (Stripe Checkout). Il Cliente riceve la fattura entro i termini di legge.
      </p>
      <ul>
        <li>In caso di mancato pagamento entro la scadenza, il Fornitore può sospendere l'accesso alla Piattaforma previa comunicazione via email</li>
        <li>Il periodo di grazia per il pagamento è di <strong>30 giorni</strong> dalla scadenza</li>
        <li>Trascorso il periodo di grazia senza regolarizzazione, l'account può essere disattivato e i dati cancellati con preavviso di 14 giorni</li>
        <li>Tutti i pagamenti sono elaborati tramite Stripe; il Fornitore non conserva i dati delle carte di credito</li>
      </ul>

      <h2>7. Rinnovo e Disdetta</h2>
      <p>
        L'abbonamento si rinnova automaticamente alla scadenza annuale, salvo disdetta da parte del Cliente. Per recedere dal contratto:
      </p>
      <ul>
        <li>La disdetta deve essere comunicata via email a <a href="mailto:info@shangrilux.com">info@shangrilux.com</a> con almeno <strong>30 giorni di anticipo</strong> rispetto alla data di rinnovo</li>
        <li>In caso di disdetta, il Cliente conserva l'accesso alla Piattaforma fino alla fine del periodo già pagato</li>
        <li>Non sono previsti rimborsi pro-rata per periodi non utilizzati, salvo diverso accordo scritto</li>
        <li>Il Cliente può esportare i propri dati in formato CSV prima della scadenza</li>
      </ul>

      <h2>8. Recesso per Giusta Causa</h2>
      <p>
        Il Cliente può recedere immediatamente dal Contratto, con diritto al rimborso del canone residuo pro-rata, nei seguenti casi:
      </p>
      <ul>
        <li>Interruzione definitiva del Servizio da parte del Fornitore</li>
        <li>Modifica sostanziale delle funzionalità del Piano che ne pregiudichi l'utilizzo previsto, senza accordo alternativo</li>
        <li>Violazione grave dei presenti Termini da parte del Fornitore</li>
      </ul>
      <p>
        Il Fornitore può recedere immediatamente in caso di:
      </p>
      <ul>
        <li>Utilizzo della Piattaforma in violazione delle leggi vigenti</li>
        <li>Mancato pagamento oltre il periodo di grazia</li>
        <li>Violazione grave degli obblighi del Cliente previsti dal presente Contratto</li>
      </ul>

      <h2>9. Funzionalità del Servizio e Feature Gate</h2>
      <p>
        Le funzionalità disponibili dipendono dal Piano sottoscritto. Il Fornitore si riserva il diritto di:
      </p>
      <ul>
        <li>Aggiungere nuove funzionalità a tutti i piani, o come funzionalità esclusive di piani superiori</li>
        <li>Modificare o rimuovere funzionalità con preavviso di almeno <strong>30 giorni</strong></li>
        <li>Limitare temporaneamente alcune funzionalità in caso di manutenzione programmata</li>
      </ul>

      <h2>10. Disponibilità del Servizio (SLA)</h2>
      <p>
        Il Fornitore si impegna a garantire la disponibilità della Piattaforma con i seguenti obiettivi:
      </p>
      <ul>
        <li><strong>Uptime target:</strong> 99,5% su base mensile, escluse manutenzioni programmate</li>
        <li><strong>Manutenzioni programmate:</strong> comunicate via email con almeno 48 ore di anticipo, preferibilmente nelle ore notturne (00:00–06:00 CET)</li>
        <li><strong>Tempo di risposta ai guasti critici:</strong> entro 4 ore lavorative (piani Elite e Professional con supporto prioritario)</li>
      </ul>
      <p>
        In caso di interruzioni prolungate non imputabili a manutenzione programmata o forza maggiore, il Cliente potrà richiedere un credito di servizio proporzionale al disservizio.
      </p>

      <h2>11. Obblighi del Cliente</h2>
      <p>Il Cliente si impegna a:</p>
      <ul>
        <li>Utilizzare la Piattaforma esclusivamente per scopi leciti e in conformità alle leggi vigenti</li>
        <li>Non tentare di accedere a sezioni della Piattaforma al di fuori del proprio Tenant assegnato</li>
        <li>Non effettuare operazioni di reverse engineering, decompilazione o disassemblaggio del software</li>
        <li>Non utilizzare la Piattaforma per inviare comunicazioni non richieste (spam) o per attività fraudolente</li>
        <li>Informare correttamente i propri Ospiti riguardo al trattamento dei loro dati personali, in qualità di Titolare autonomo del trattamento</li>
        <li>Rispettare tutte le normative applicabili in materia di privacy e protezione dei dati (GDPR)</li>
        <li>Mantenere un numero di utenti admin entro i limiti del Piano sottoscritto</li>
      </ul>

      <h2>12. Proprietà Intellettuale</h2>
      <p>
        La Piattaforma Shangrilux, inclusi il software, il design, i loghi, la documentazione e qualsiasi altro materiale, è di esclusiva proprietà del Fornitore e protetta dalle leggi sul diritto d'autore e sulla proprietà intellettuale.
      </p>
      <p>
        Il presente Contratto non trasferisce al Cliente alcun diritto di proprietà intellettuale sulla Piattaforma. Il Cliente ottiene esclusivamente una licenza d'uso limitata, non esclusiva e non trasferibile, per la durata del periodo di abbonamento.
      </p>
      <p>
        I dati inseriti dal Cliente nella Piattaforma (prenotazioni, informazioni sulle proprietà, dati degli ospiti) rimangono di proprietà del Cliente.
      </p>

      <h2>13. Riservatezza</h2>
      <p>
        Entrambe le parti si impegnano a mantenere la riservatezza di tutte le informazioni confidenziali ricevute dall'altra parte nell'ambito del rapporto contrattuale. Sono escluse dall'obbligo di riservatezza le informazioni che:
      </p>
      <ul>
        <li>Siano di pubblico dominio al momento della divulgazione o lo diventino successivamente senza colpa della parte ricevente</li>
        <li>Debbano essere divulgate per obbligo di legge o ordine dell'autorità giudiziaria</li>
      </ul>

      <h2>14. Trattamento dei Dati Personali (DPA)</h2>
      <p>
        Nella misura in cui il Cliente carica sulla Piattaforma dati personali dei propri Ospiti o collaboratori, il Fornitore agisce come <strong>Responsabile del Trattamento</strong> ai sensi dell'art. 28 GDPR. Il Fornitore si impegna a:
      </p>
      <ul>
        <li>Trattare i dati esclusivamente secondo le istruzioni documentate del Cliente</li>
        <li>Adottare misure di sicurezza adeguate ai sensi dell'art. 32 GDPR</li>
        <li>Non trasferire i dati a terzi se non per finalità strettamente necessarie all'erogazione del Servizio</li>
        <li>Assistere il Cliente nel rispondere alle richieste degli interessati (artt. 15-22 GDPR)</li>
        <li>Cancellare o restituire i dati al termine del Contratto, su richiesta del Cliente</li>
      </ul>
      <p>
        Per ulteriori dettagli, si rimanda alla <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>15. Esclusione di Garanzie e Limitazione di Responsabilità</h2>
      <p>
        La Piattaforma è fornita "così com'è" (<em>as is</em>). Nei limiti consentiti dalla legge:
      </p>
      <ul>
        <li>Il Fornitore non garantisce che la Piattaforma sia priva di errori o interruzioni in ogni momento</li>
        <li>La responsabilità complessiva del Fornitore per danni diretti non potrà in alcun caso superare il totale dei canoni pagati dal Cliente nei <strong>12 mesi precedenti</strong> al verificarsi del danno</li>
        <li>Il Fornitore non è responsabile per danni indiretti, perdita di profitto, danni reputazionali o perdita di dati derivanti dall'utilizzo o dall'impossibilità di utilizzo della Piattaforma</li>
        <li>Le limitazioni di responsabilità non si applicano in caso di dolo o colpa grave del Fornitore</li>
      </ul>

      <h2>16. Forza Maggiore</h2>
      <p>
        Il Fornitore non è responsabile per ritardi o inadempimenti causati da eventi di forza maggiore, inclusi ma non limitati a: disastri naturali, interruzioni di infrastrutture internet, attacchi informatici di terze parti, provvedimenti governativi o pandemie.
      </p>

      <h2>17. Modifiche ai Termini</h2>
      <p>
        Il Fornitore si riserva il diritto di modificare i presenti Termini e Condizioni. Le modifiche sostanziali verranno comunicate al Cliente via email con almeno <strong>30 giorni di preavviso</strong>. L'utilizzo continuato della Piattaforma dopo tale termine costituisce accettazione delle modifiche. In caso di disaccordo, il Cliente può recedere dal Contratto senza penali entro il periodo di preavviso.
      </p>

      <h2>18. Legge Applicabile e Foro Competente</h2>
      <p>
        Il presente Contratto è regolato dalla <strong>legge italiana</strong>. Per qualsiasi controversia relativa all'interpretazione, all'esecuzione o alla risoluzione del presente Contratto, le parti convengono la competenza esclusiva del <strong>Tribunale del luogo di residenza del Fornitore</strong>, rinunciando a qualsiasi altro foro eventualmente competente.
      </p>

      <h2>19. Disposizioni Generali</h2>
      <ul>
        <li><strong>Integralità del Contratto:</strong> il presente documento, unitamente alla Privacy Policy, alla Cookie Policy e all'eventuale DPA, costituisce l'integrale accordo tra le parti con riferimento all'oggetto del Contratto.</li>
        <li><strong>Nullità parziale:</strong> qualora una clausola del presente Contratto risulti invalida o inapplicabile, le restanti clausole rimarranno pienamente valide ed efficaci.</li>
        <li><strong>Rinuncia:</strong> la mancata esercitazione di un diritto da parte del Fornitore non costituisce rinuncia al medesimo diritto in futuro.</li>
        <li><strong>Comunicazioni:</strong> tutte le comunicazioni formali devono essere inviate all'indirizzo email del Fornitore: <a href="mailto:info@shangrilux.com">info@shangrilux.com</a>.</li>
      </ul>

      <h2>20. Contatti</h2>
      <p>Per qualsiasi domanda o chiarimento sui presenti Termini e Condizioni:</p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:info@shangrilux.com">info@shangrilux.com</a></li>
        <li><strong>Piattaforma:</strong> <a href="https://shangrilux.com">https://shangrilux.com</a></li>
      </ul>

    </LegalPage>
  );
}
